module.exports = __webpack_public_path__ + "d72d96ed20c8d95bfc8b99d4c5015898.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/logos/wr-logo.png
// module id = 301
// module chunks = 0